import { useEffect, useState } from "react";
import { getDashboardAgentStatistics } from "../../utils/awsAPI";
import { IoRefreshCircleOutline } from "react-icons/io5";
import { Form } from "react-bootstrap";
import { useSelector } from "react-redux";
import { RiUserVoiceLine, RiUserUnfollowLine, RiUserFollowLine, RiUserSharedLine } from "react-icons/ri"; 



const AgentStats = () => {
    const [Repeat, setRepeat] =  useState(true);
    const [time, setTime] = useState(Date.now());
    const agentObj = useSelector((state:any)=>{return state.agentSlice.agentObj})
    const [selectedQueue, setSelectedQueue] = useState<any>([])
    const [currentMetricData, setCurrentMetricData] = useState({ AGENTS_AVAILABLE: 0, AGENTS_NON_PRODUCTIVE: 0, AGENTS_ONLINE: 0, AGENTS_ON_CONTACT: 0 });
    const [clickRefresh, setClickRefresh] = useState(false);
    
    useEffect(() => {
        const getDashboardData = async () => {
            let queueIds = [];
            if(selectedQueue.length === 0) {
                let queueList = (agentObj) ? agentObj.getRoutingProfile().queues:[];
                let resultQueue = queueList.filter((queue:any) => queue.queueId.indexOf('agent') === -1)
                                            .map((queue:any) => {
                                                let result = queue;
                                                result.isSelected = true;
                                                return result;
                                            })
                setSelectedQueue(resultQueue)
                queueIds = resultQueue.map((queue:any) => queue.queueId)
            } else {
                queueIds = selectedQueue.filter((queue:any) => queue.isSelected === true).map((queue:any) => queue.queueId)
            }
            if(queueIds.length > 0) {
                const agentStatisticsResponse = await getDashboardAgentStatistics(queueIds);
                if(agentStatisticsResponse) {
                    if(Object.keys(agentStatisticsResponse.CurrentMetric).length > 0) {
                        setCurrentMetricData(agentStatisticsResponse.CurrentMetric)
                    } else {
                        setCurrentMetricData({ AGENTS_AVAILABLE: 0, AGENTS_NON_PRODUCTIVE: 0, AGENTS_ONLINE: 0, AGENTS_ON_CONTACT: 0 })
                    }
                }
            }
        }
        if (Repeat){
        const interval = setInterval(() => setTime(Date.now()), 10000);
        setRepeat(false)
        }
        getDashboardData();
        
        
    },[clickRefresh, selectedQueue, agentObj,time])

    const onClickRefresh = () => {
        setClickRefresh((preState)=>!preState)
    }

    const onQueueSelect = (queueData:any, status:any) => {
        let changeStatus = !status;
        let updateData = selectedQueue.map((queue:any) => {
            if(queueData.queueId === queue.queueId) {
                let result = queue
                result.isSelected = changeStatus
                return result
            } else {
                return queue
            }
        })
        setSelectedQueue(updateData)
    }

    return (
        <div className="card agent-satistic collapse show mt-3" id="agent_satistic">
            <div className="card-header d-flex justify-content-between align-items-center">
                <h6 className='m-0'>Agent statistics</h6>
                <div className='d-flex'>
                    <div className="dropdown">
                        <button type="button" className={`btn btn-sm dropdown-toggle`} data-bs-toggle="dropdown">
                            Select queues
                        </button>
                        <ul className="dropdown-menu">
                            <li>
                                {selectedQueue && selectedQueue
                                    .map((queue:any) => {
                                        return <Form.Check onChange={() => onQueueSelect(queue, queue.isSelected)} checked={queue.isSelected} label={queue.name} key={queue.queueId} className="dropdown-item" />
                                    })
                                }
                            </li>
                        </ul>
                    </div>
                    <button title="Refresh" className="refresh-btn" onClick={() =>{ onClickRefresh(); }}><IoRefreshCircleOutline /></button>
                </div>
            </div>
            <div className="card-body height-200">
                <ul className='agent-satistic-list list-unstyled m-0'>
                <li><span><RiUserSharedLine/> Logged in</span><strong>{currentMetricData?.AGENTS_ONLINE }</strong></li>
                    <li><span><RiUserFollowLine fill="#006600"/> Ready</span><strong>{currentMetricData?.AGENTS_AVAILABLE}</strong></li>
                    <li><span><RiUserUnfollowLine fill="#B30000"/> Not ready</span><strong>{ currentMetricData?.AGENTS_NON_PRODUCTIVE }</strong></li>
                    <li><span><RiUserVoiceLine fill="blue"/> Busy</span><strong>{ currentMetricData?.AGENTS_ON_CONTACT }</strong></li>
                </ul>
            </div>
        </div>
    )
}
export default AgentStats;